import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=ce2e09d8&scoped=true&"
import script from "./menu-item.vue?vue&type=script&lang=js&"
export * from "./menu-item.vue?vue&type=script&lang=js&"
import style0 from "./menu-item.vue?vue&type=style&index=0&id=ce2e09d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2e09d8",
  null
  
)

export default component.exports